import * as actionTypes from './actionsTypes';

export const setShipmentManagementSearchParams = (shipmentSearchParams) => {
  return {
    type: actionTypes.SETSHIPMENTMANAGEMENTSEARCHPARAMS,
    data: shipmentSearchParams,
  };
};
